module.exports = __webpack_public_path__ + "assets/img/youke.19a5bb3f.png";